import moment from 'moment';

export const formatDate = (date: string | Date): string => {
  return date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
};

export const formatDateTime = (date: string | Date, format: string = 'LLL'): string => {
  return date ? moment(date).format(format) : '';
};

export const formatCurrency = (value: number): string => {
  return String(value).formatMoney();
};

export const formatMassiveUpload = (mu: any) => {
  return {
    ...mu,
    createdAt: formatDateTime(mu.createdAt, 'LLL'),
  };
};
